import { Tag } from '../customerTrackingCreator';

export const filterAvailableTags = (tags: Tag[]) => {
  return tags.filter((tag) => tag.isAvailable());
};
